import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { PlatformUtil } from 'src/app/shared/utils/platform/plataform.util';
import { environment } from 'src/environments/environment';

@Injectable()
export class CmsLobbyChannelInterceptor implements HttpInterceptor {
  private readonly platformUtil = inject(PlatformUtil);

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const cmsUrl = environment.endpointBasePaths.cmsApiUrl;
    if (
      !cmsUrl ||
      !req.url.startsWith(cmsUrl) ||
      !this.platformUtil.isNativeApp() ||
      !req.url.includes('public/catalog/games')
    ) {
      return next.handle(req);
    }
    return next.handle(
      req.clone({
        setHeaders: {
          'X-Canal': String(this.platformUtil.lobbyCanal()),
          'X-Origen': this.platformUtil.lobbyOrigen(),
        },
      })
    );
  }
}
